import { UserRowRoleType } from '@modules/users/store/types';
import { InviteUserRoleType } from '@modules/users/types';
import { trackUserManagementEvents } from '@modules/workspaceSettings/utils';
import { MenuItem, Select, SelectChangeEvent } from '@mui/material';

interface InviteUsersRoleSelectProps {
  selectedRole: InviteUserRoleType;
  onChange: (role: InviteUserRoleType) => void;
  isDisabled?: boolean;
  selectedEmails: string[];
}

export const InviteUsersRoleSelect = ({
  selectedRole,
  onChange,
  isDisabled,
  selectedEmails,
}: InviteUsersRoleSelectProps) => {
  const handleChange = (event: SelectChangeEvent<InviteUserRoleType>) => {
    const selectedRole = event.target.value as InviteUserRoleType;
    onChange(selectedRole);
    trackUserManagementEvents({
      eventName: 'User Management - Invite Users: Selected User Role',
      invitedUserEmails: selectedEmails,
    });
  };

  return (
    <Select
      fullWidth
      size="small"
      value={selectedRole}
      onChange={handleChange}
      disabled={isDisabled}
    >
      <MenuItem value={UserRowRoleType.Member}>as Member</MenuItem>
      <MenuItem value={UserRowRoleType.Admin}>as Admin</MenuItem>
    </Select>
  );
};
